/* Panel „Napisz do nas” — przeniesiony 1:1 z obecnego sklepu CGH (tools/sklep_wzorzec/kod/assets/sb-pomoc.js) [Yuri 11.10: „zdecydowanie podoba mi się to okno”]. */
/* NAPISZ DO NAS — panel kontaktu ze sklepu → Helpdesk w apce merch.help.

   [Yuri 2026-10-07] Spec: docs/superpowers/specs/2026-10-07-helpdesk-design.md.
   Cztery sprawy, każda wchodzi tam, gdzie powstaje potrzeba:
     nadruk     — karta pod „Dodaj do koszyka” (zastępuje „Zapytaj o nadruk”)
     wycena     — link pod tabelą progów
     zamowienie — link w stopce
     szukam     — ostatni kafel siatki kategorii
   Wejście to dowolny element z `data-sb-pomoc="<typ>"`.

   Kontekst produktu czytamy z karty (tytuł, uchwyt, wariant, ilość) — klient
   niczego nie przepisuje. Odrzucone i nie wracać: godzina odpowiedzi w
   potwierdzeniu, twarz opiekuna, ogólna „Pomoc” w nagłówku. */
(function () {
  /* [08.10, CGH] PL/EN — język strony z <html lang>. Polski jest kluczem, angielski tłumaczeniem. */
  var L = (document.documentElement.lang || 'pl').slice(0, 2);
  var EN = {
      "Co się stało?": "What happened?",
      "Czego szukasz i na jaką okazję?": "What are you looking for, and what’s the occasion?",
      "Dostaniesz wycenę z terminem realizacji": "We’ll send a quote with a lead time",
      "Dołącz plik": "Attach a file",
      "Dołącz zdjęcie": "Attach a photo",
      "Dziękujemy.": "Thanks.",
      "Ilość": "Quantity",
      "Moje zamówienie": "My order",
      "Na adres ": "To ",
      "Nadruk i personalizacja": "Printing and personalisation",
      "Oczywiście, że personalizujemy": "Of course we personalise",
      "Znakowanie": "Branding",
      "Dobierzemy technikę do materiału.": "We’ll match the technique to the material.",
      "Co i na czym znakujemy?": "What should we brand, and on what?",
      "np. logo na stalowych kubkach i bawełnianych torbach": "e.g. a logo on steel tumblers and cotton tote bags",
      "Logo (AI, SVG, PDF albo PNG)": "Logo (AI, SVG, PDF or PNG)",
      "Pokażemy, jak to będzie wyglądać.": "We’ll show you exactly how it will look.",
      "Co mamy zaprojektować?": "What should we design?",
      "np. logo na bluzach i kubkach na onboarding": "e.g. a logo on hoodies and mugs for onboarding",
      "Termin i dostawa": "Timing and delivery",
      "Powiedz, na kiedy i dokąd.": "Tell us when and where.",
      "Co zamawiasz?": "What are you ordering?",
      "np. 40 bluz i 40 kubków": "e.g. 40 hoodies and 40 mugs",
      "Dokąd?": "Where to?",
      "Dostawa": "Delivery",
      "np. budowa w Gdańsku": "e.g. a site in Gdańsk",
      "Własny pomysł": "Your own idea",
      "Opowiedz, co masz w głowie.": "Tell us what you have in mind.",
      "np. otwieracz w kształcie klucza dla 200 osób na jubileusz": "e.g. a wrench-shaped bottle opener for 200 people for an anniversary",
      "Szkic albo inspiracja": "A sketch or inspiration",
      "Dobierzemy technikę i przygotujemy projekt": "We’ll pick the technique and prepare the artwork",
      "Przygotujemy projekt": "We’ll prepare the artwork",
      "Projekt": "Artwork",
      "Potwierdzimy termin i sposób dostawy": "We’ll confirm the timing and delivery",
      "Podeślemy propozycję z wyceną": "We’ll send a proposal with a quote",
      "Każda sztuka może mieć coś swojego.": "Every piece can have something of its own.",
      "Co dodać i gdzie?": "What should we add, and where?",
      "Szukasz czegoś innego?": "Looking for something else?",
      "Nie udało się wysłać. Spróbuj jeszcze raz za chwilę.": "Something went wrong. Please try again in a moment.",
      "Numer zamówienia": "Order number",
      "Numer ": "Order ",
      "Przyjęte": "Received",
      "Co dalej": "What happens next",
      "Odpowiedź": "Reply",
      "na adres ": "to ",
      "Odpowiadamy w dni robocze w ciągu 4 h, 9–17": "We reply within 4 hours on working days, 9:00-17:00",
      "Opisz, czego potrzebujesz": "Describe what you need",
      "Opis": "Description",
      "Plik jest za duży — maksymalnie 25 MB.": "That file is over 25 MB.",
      "Pliki": "Files",
      "Podeślemy propozycje produktów": "We’ll suggest a few products",
      "Poproś o wycenę": "Request a quote",
      "Produkt": "Product",
      "Przygotujemy projekt nadruku": "We’ll prepare the print artwork",
      "Sprawdzimy zamówienie i odpiszemy ze szczegółami": "We’ll look into it and get back to you",
      "Sprawdź adres e-mail.": "Please check the email address.",
      "Termin": "Needed by",
      "Ustalimy szczegóły i odpiszemy": "We’ll confirm the details with you",
      "Uwagi": "Notes",
      "Uzupełnij zaznaczone pola.": "Please complete the highlighted fields.",
      "Wycena większej ilości": "Quote for bulk orders",
      "Wyślij zgłoszenie": "Send",
      "Wyślij kolejne zgłoszenie": "Send another request",
      "Wyślij": "Send",
      "Wróć do sklepu": "Back to the shop",
      "Treść zgłoszenia": "Your message",
      "Zamówienie": "Order",
      "Zdjęcie lub inspiracja": "Photo or reference",
      "Zgłoszenie przyjęte": "Request received",
      "Znajdziemy to dla Ciebie": "We’ll find it for you",
      "Mamy Twoje zgłoszenie.": "We’ve got your request.",
      "dziś do ": "today by ",
      "jutro do ": "tomorrow by ",
      "w poniedziałek": "on Monday",
      "we wtorek": "on Tuesday",
      "w środę": "on Wednesday",
      "w czwartek": "on Thursday",
      "w piątek": "on Friday",
      "w sobotę": "on Saturday",
      "w niedzielę": "on Sunday",
      "np. brakuje dwóch koszulek w rozmiarze M": "e.g. two medium T-shirts missing",
      "np. imiona członków zespołu na plecach, logo działu na rękawie": "e.g. names on the back, team logo on the sleeve",
      "np. prezent dla 40 osób na jubileusz placówki, budżet ok. 100 zł na osobę": "e.g. gifts for 40 people for an anniversary, around PLN 100 each",
      "np. różne rozmiary, dostawa do kilku placówek": "e.g. mixed sizes, delivery to several sites",
      "(opcjonalnie)": "(optional)",
      " szt.": " pcs",
      "Coś nie tak z zamówieniem?": "Something wrong with your order?",
      "Ile sztuk?": "How many pieces?",
      "Imię i nazwisko": "Full name",
      "Logowanie kodem z maila, bez hasła": "Sign in with an emailed code. No password needed.",
      "Moje zamówienia →": "My orders →",
      "Na kiedy?": "Needed by?",
      "PDF, AI, SVG, PNG, JPG, XLSX · do 25 MB": "PDF, AI, SVG, PNG, JPG, XLSX · up to 25 MB",
      "Status, śledzenie i faktury": "Status, tracking and invoices",
      "albo": "or",
      "Zamknij": "Close",
      "np. #1042": "e.g. #1042",
      "np. 15 listopada": "e.g. 15 November",
      "Zestaw na zamówienie": "Custom set",
      "Opowiedz nam o swoim wymarzonym zestawie": "Tell us about your perfect set",
      "Co ma się znaleźć w zestawie i na jaką okazję?": "What should go in the set, and what’s the occasion?",
      "np. bluza, kubek termiczny i notes na onboarding nowych osób": "e.g. a hoodie, travel mug and notebook for new starters",
      "Dla ilu osób?": "How many people?",
      "Budżet na jeden zestaw": "Budget per set",
      "Budżet na zestaw": "Budget per set",
      "np. 150 zł": "e.g. PLN 150",
      "Inspiracja albo lista produktów": "Inspiration or product list",
      "Personalizacja": "Personalisation",
      "Imiona, inicjały, nazwiska na każdej sztuce": "Names or initials on every item",
      "Co personalizujemy i gdzie?": "What should we personalise, and where?",
      "np. imię i nazwisko na każdym notesie, inicjały na kubkach": "e.g. a full name on each notebook, initials on the mugs",
      "Lista imion (XLSX, CSV) albo projekt": "Name list (XLSX, CSV) or artwork",
      "Rozmiary dla zespołu": "Team sizing",
      "Pomożemy rozłożyć zamówienie na rozmiary": "We’ll help you work out the sizes",
      "Ile osób?": "How many people?",
      "Co wiesz o zespole?": "What do you know about the team?",
      "np. 12 osób, głównie M i L, dwie osoby XXL": "e.g. 12 people, mostly M and L, two XXL",
      "Napisz do nas": "Contact us",
      "W czym możemy pomóc?": "How can we help?",
      "Twoja wiadomość": "Your message",
      "np. pytanie o produkt, termin albo zamówienie": "e.g. a question about a product, timing or an order",
      "Podeślemy propozycję zestawu z wyceną": "We’ll send a set proposal with a quote",
      "Przygotujemy projekt personalizacji": "We’ll prepare the personalisation artwork",
      "Podpowiemy rozkład rozmiarów": "We’ll suggest a size breakdown",
      "Odpiszemy na Twoją wiadomość": "We’ll get back to you",
      "Ile zestawów?": "How many sets?"
  };
  function T(s) { return L === 'en' && EN[s] ? EN[s] : s; }
  var URL_WORKERA = 'https://merch-help-wiedza.doradca.workers.dev/pomoc';
  var OBIETNICA = T('Odpowiadamy w dni robocze w ciągu 4 h, 9–17');
  var MAX_PLIK = 25 * 1024 * 1024;
  var AKCEPT = '.pdf,.ai,.eps,.svg,.png,.jpg,.jpeg,.webp,.xlsx,.xls,.csv,.docx';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function produkt() {
    if (window.SV2_KONTEKST) return window.SV2_KONTEKST();   /* [sklep v2] karta v2 podaje kontekst sama */
    var t = document.querySelector('.product-details h1');
    if (!t) return null;
    var img = document.querySelector('.product-information .product-media img');
    var wariant = document.querySelector('.product-information input[name="id"], .product-information [name="id"]');
    var zazn = [].slice.call(document.querySelectorAll('.product-information .variant-option input:checked')).map(function (i) { return i.value; });
    var ilosc = document.querySelector('.sb-wlasna input');
    var prog = document.querySelector('.sb-prog.on b');
    var n = (ilosc && parseInt(ilosc.value, 10)) || (prog && parseInt(prog.textContent, 10)) || 1;
    return {
      tytul: t.textContent.trim(),
      uchwyt: (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '',
      wariant_id: wariant ? wariant.value : '',
      wariant: zazn.join(' / '),
      ilosc: n,
      obraz: img ? img.currentSrc : ''
    };
  }

  function kategoria() {
    var h = document.querySelector('.sb-naglowek-kat h1, .lista-g h1');
    return h ? h.textContent.trim() : '';
  }

  var pole = {
    opis: function (etyk, ph, wym) { return '<div class="sbp-pole"><label for="sbp-opis">' + etyk + (wym ? '' : ' <span>' + T('(opcjonalnie)') + '</span>') + '</label><textarea id="sbp-opis" name="opis" ' + (wym ? 'required ' : '') + 'placeholder="' + ph + '"></textarea></div>'; },
    plik: function (etyk) { return '<div class="sbp-plik"><input id="sbp-plik" type="file" name="pliki" multiple accept="' + AKCEPT + '"><label for="sbp-plik"><i aria-hidden="true">↑</i><span><b>' + etyk + '</b> <em>' + T('(opcjonalnie)') + '</em><br>' + T('PDF, AI, SVG, PNG, JPG, XLSX · do 25 MB') + '</span></label><ul class="sbp-pliki" aria-live="polite"></ul></div>'; },
    kto: '<div class="sbp-dwa"><div class="sbp-pole"><label for="sbp-imie">' + T('Imię i nazwisko') + '</label><input id="sbp-imie" name="imie" autocomplete="name" required></div><div class="sbp-pole"><label for="sbp-email">E-mail</label><input id="sbp-email" name="email" type="email" autocomplete="email" required></div></div>',
    email: '<div class="sbp-pole"><label for="sbp-email">E-mail</label><input id="sbp-email" name="email" type="email" autocomplete="email" required></div>'
  };

  function kartaProduktu(p, pokazIlosc) {
    if (!p) return '';
    return '<div class="sbp-ctx">' + (p.obraz ? '<img src="' + esc(p.obraz) + '" alt="">' : '') +
      '<div><b>' + esc(p.tytul) + '</b><span>' + esc([p.wariant, pokazIlosc ? p.ilosc + T(' szt.') : ''].filter(Boolean).join(' · ')) + '</span></div></div>';
  }

  var SPRAWY = {
    nadruk: function () {
      var p = produkt();
      return { tytul: T('Nadruk i personalizacja'), cta: T('Wyślij'), html:
        kartaProduktu(p, true) +
        pole.opis(T('Opisz, czego potrzebujesz'), T('np. imiona członków zespołu na plecach, logo działu na rękawie'), true) +
        pole.plik(T('Dołącz plik')) + pole.kto, ctx: p };
    },
    wycena: function () {
      var p = produkt();
      var n = p && p.ilosc > 10 ? p.ilosc : '';
      return { tytul: T('Wycena większej ilości'), cta: T('Poproś o wycenę'), html:
        kartaProduktu(p, false) +
        '<div class="sbp-dwa"><div class="sbp-pole"><label for="sbp-ilosc">' + (p && /zestaw/i.test(p.tytul) ? T('Ile zestawów?') : T('Ile sztuk?')) + '</label><input id="sbp-ilosc" name="ilosc" inputmode="numeric" required value="' + n + '"></div>' +
        '<div class="sbp-pole"><label for="sbp-termin">' + T('Na kiedy?') + ' <span>' + T('(opcjonalnie)') + '</span></label><input id="sbp-termin" name="termin" placeholder="' + T('np. 15 listopada') + '"></div></div>' +
        pole.opis(T('Uwagi'), T('np. różne rozmiary, dostawa do kilku placówek'), false) + pole.kto, ctx: p };
    },
    zamowienie: function () {
      return { tytul: T('Moje zamówienie'), cta: T('Wyślij zgłoszenie'), html:
        '<a class="sbp-samo" href="' + ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'account"><span><b>' + T('Status, śledzenie i faktury') + '</b><small>' + T('Logowanie kodem z maila, bez hasła') + '</small></span><em>' + T('Moje zamówienia →') + '</em></a>' +
        '<div class="sbp-lub">' + T('albo') + '</div><h3 class="sbp-h3">' + T('Coś nie tak z zamówieniem?') + '</h3>' +
        '<div class="sbp-pole"><label for="sbp-nr">' + T('Numer zamówienia') + '</label><input id="sbp-nr" name="numer_zamowienia" required placeholder="' + T('np. #1042') + '"></div>' +
        pole.opis(T('Co się stało?'), T('np. brakuje dwóch koszulek w rozmiarze M'), true) +
        pole.plik(T('Dołącz zdjęcie')) + pole.email, ctx: null };
    },
    /* [sklep v2, Yuri 11.10] każde wejście dostaje formularz o swojej sprawie; do Workera idzie jeden z 4 typów (TYP_WORKERA) */
    zestaw: function () {
      var p = produkt(), zestaw = p && /zestaw/i.test(p.tytul) ? p : null;
      return { tytul: T('Zestaw na zamówienie'), cta: T('Wyślij'), naglowek: T('Opowiedz nam o swoim wymarzonym zestawie'), html:
        (zestaw ? kartaProduktu(zestaw, false) : '') +
        pole.opis(T('Co ma się znaleźć w zestawie i na jaką okazję?'), T('np. bluza, kubek termiczny i notes na onboarding nowych osób'), true) +
        '<div class="sbp-dwa"><div class="sbp-pole"><label for="sbp-ilosc">' + T('Dla ilu osób?') + '</label><input id="sbp-ilosc" name="ilosc" inputmode="numeric" required></div>' +
        '<div class="sbp-pole"><label for="sbp-termin">' + T('Na kiedy?') + ' <span>' + T('(opcjonalnie)') + '</span></label><input id="sbp-termin" name="termin" placeholder="' + T('np. 15 listopada') + '"></div></div>' +
        '<div class="sbp-pole"><label for="sbp-budzet">' + T('Budżet na jeden zestaw') + ' <span>' + T('(opcjonalnie)') + '</span></label><input id="sbp-budzet" name="budzet" data-do-opisu="' + T('Budżet na zestaw') + '" placeholder="' + T('np. 150 zł') + '"></div>' +
        pole.plik(T('Inspiracja albo lista produktów')) + pole.kto, ctx: { temat: 'zestaw na zamówienie', zestaw: zestaw && zestaw.tytul } };
    },
    /* [Yuri 14.10] sprawy z kafli-filmów: każdy kafel otwiera formularz o SWOJEJ sprawie (nie ogólne „Jak możemy pomóc?”) */
    technika: function () {
      return { tytul: T('Znakowanie'), cta: T('Wyślij'), naglowek: T('Dobierzemy technikę do materiału.'), html:
        pole.opis(T('Co i na czym znakujemy?'), T('np. logo na stalowych kubkach i bawełnianych torbach'), true) +
        pole.plik(T('Logo (AI, SVG, PDF albo PNG)')) + pole.kto, ctx: { temat: 'technika znakowania' } };
    },
    projekt: function () {
      return { tytul: T('Projekt'), cta: T('Wyślij'), naglowek: T('Pokażemy, jak to będzie wyglądać.'), html:   /* [Yuri 21.10] bez „do akceptacji” */
        pole.opis(T('Co mamy zaprojektować?'), T('np. logo na bluzach i kubkach na onboarding'), true) +
        pole.plik(T('Logo (AI, SVG, PDF albo PNG)')) + pole.kto, ctx: { temat: 'projekt' } };
    },
    termin: function () {
      return { tytul: T('Termin i dostawa'), cta: T('Wyślij'), naglowek: T('Powiedz, na kiedy i dokąd.'), html:
        pole.opis(T('Co zamawiasz?'), T('np. 40 bluz i 40 kubków'), true) +
        '<div class="sbp-dwa"><div class="sbp-pole"><label for="sbp-termin">' + T('Na kiedy?') + '</label><input id="sbp-termin" name="termin" required placeholder="' + T('np. 15 listopada') + '"></div>' +
        '<div class="sbp-pole"><label for="sbp-dokad">' + T('Dokąd?') + ' <span>' + T('(opcjonalnie)') + '</span></label><input id="sbp-dokad" name="dokad" data-do-opisu="' + T('Dostawa') + '" placeholder="' + T('np. budowa w Gdańsku') + '"></div></div>' +
        pole.kto, ctx: { temat: 'termin i dostawa' } };
    },
    pomysl: function () {
      return { tytul: T('Własny pomysł'), cta: T('Wyślij'), naglowek: T('Opowiedz, co masz w głowie.'), html:
        pole.opis(T('Czego szukasz i na jaką okazję?'), T('np. otwieracz w kształcie klucza dla 200 osób na jubileusz'), true) +
        pole.plik(T('Szkic albo inspiracja')) + pole.kto, ctx: { temat: 'własny pomysł' } };
    },
    personalizacja: function () {
      var p = produkt();
      return { tytul: T('Personalizacja'), cta: T('Wyślij'), naglowek: T('Każda sztuka może mieć coś swojego.'), html:
        kartaProduktu(p, true) +
        pole.opis(T('Co dodać i gdzie?'), T('np. imię i nazwisko na każdym notesie, inicjały na kubkach'), true) +
        '<div class="sbp-pole"><label for="sbp-ilosc">' + T('Ile sztuk?') + ' <span>' + T('(opcjonalnie)') + '</span></label><input id="sbp-ilosc" name="ilosc" inputmode="numeric"></div>' +
        pole.plik(T('Lista imion (XLSX, CSV) albo projekt')) + pole.kto, ctx: Object.assign({ temat: 'personalizacja' }, p || {}) };
    },
    rozmiary: function () {
      var p = produkt();
      return { tytul: T('Rozmiary dla zespołu'), cta: T('Wyślij'), naglowek: T('Pomożemy rozłożyć zamówienie na rozmiary'), html:
        kartaProduktu(p, false) +
        '<div class="sbp-dwa"><div class="sbp-pole"><label for="sbp-ilosc">' + T('Ile osób?') + '</label><input id="sbp-ilosc" name="ilosc" inputmode="numeric" required></div>' +
        '<div class="sbp-pole"><label for="sbp-termin">' + T('Na kiedy?') + ' <span>' + T('(opcjonalnie)') + '</span></label><input id="sbp-termin" name="termin"></div></div>' +
        pole.opis(T('Co wiesz o zespole?'), T('np. 12 osób, głównie M i L, dwie osoby XXL'), false) + pole.kto, ctx: Object.assign({ temat: 'rozmiary' }, p || {}) };
    },
    kontakt: function () {
      return { tytul: T('Napisz do nas'), cta: T('Wyślij'), naglowek: T('W czym możemy pomóc?'), html:
        pole.opis(T('Twoja wiadomość'), T('np. pytanie o produkt, termin albo zamówienie'), true) + pole.kto, ctx: { temat: 'kontakt' } };
    },
    szukam: function () {
      return { tytul: T('Szukasz czegoś innego?'), cta: T('Wyślij'), naglowek: T('Znajdziemy to dla Ciebie'), html:
        pole.opis(T('Czego szukasz i na jaką okazję?'), T('np. prezent dla 40 osób na jubileusz placówki, budżet ok. 100 zł na osobę'), true) +
        '<div class="sbp-dwa"><div class="sbp-pole"><label for="sbp-ilosc">' + T('Ile sztuk?') + ' <span>' + T('(opcjonalnie)') + '</span></label><input id="sbp-ilosc" name="ilosc" inputmode="numeric"></div>' +
        '<div class="sbp-pole"><label for="sbp-termin">' + T('Na kiedy?') + ' <span>' + T('(opcjonalnie)') + '</span></label><input id="sbp-termin" name="termin"></div></div>' +
        pole.plik(T('Zdjęcie lub inspiracja')) + pole.kto, ctx: { kategoria: kategoria() } };
    }
  };

  var panel, tlo, skad, otwarty;

  function zamknij() {
    if (!panel) return;
    panel.classList.remove('on'); tlo.classList.remove('on');
    document.documentElement.classList.remove('sbp-blokada');
    var p = panel, t = tlo; panel = tlo = null;
    setTimeout(function () { p.remove(); t.remove(); }, 580);   /* = czas ruchu panelu (pomoc.css .sbp 0,56 s) — wcześniej ucinało zamknięcie */
    document.removeEventListener('keydown', klawisz);
    if (skad && skad.focus) skad.focus();
  }

  function klawisz(e) {
    if (e.key === 'Escape') { zamknij(); return; }
    if (e.key !== 'Tab' || !panel) return;
    var f = [].slice.call(panel.querySelectorAll('a[href],button,input,textarea,[tabindex]')).filter(function (x) { return !x.disabled && x.offsetParent !== null; });
    if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }

  function otworz(typ, zrodlo) {
    if (!SPRAWY[typ]) return;
    var TYP_WORKERA = { zestaw: 'szukam', personalizacja: 'nadruk', rozmiary: 'szukam', kontakt: 'szukam', technika: 'nadruk', projekt: 'nadruk', termin: 'szukam', pomysl: 'szukam' };
    if (panel) zamknij();
    skad = zrodlo || document.activeElement;
    var s = SPRAWY[typ]();
    otwarty = { typ: TYP_WORKERA[typ] || typ, sprawa: typ, ctx: s.ctx };
    tlo = document.createElement('div'); tlo.className = 'sbp-tlo'; tlo.addEventListener('click', zamknij);
    panel = document.createElement('aside');
    panel.className = 'sbp'; panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true'); panel.setAttribute('aria-labelledby', 'sbp-tytul');
    panel.innerHTML =
      '<div class="sbp__gora"><h2 id="sbp-tytul">' + s.tytul + '</h2><button type="button" class="sbp__x" aria-label="' + T('Zamknij') + '"><svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg></button></div>' +
      '<form class="sbp__form" novalidate>' +
      '<div class="sbp__tresc">' + (s.naglowek ? '<p class="sbp-naglowek">' + s.naglowek + '</p>' : '') + s.html +
      '<input type="text" name="strona_www" class="sbp-miod" tabindex="-1" autocomplete="off" aria-hidden="true">' +
      '<p class="sbp-blad" role="alert" hidden></p></div>' +
      '<div class="sbp__dol"><button type="submit" class="sbp__cta">' + s.cta + '</button><p class="sbp__sla">' + OBIETNICA + '</p></div></form>';
    document.body.append(tlo, panel);
    /* [19.10, Jerzy: „imię i mail są zbędne, jesteś zalogowany, więc wiemy, kim jesteś”] w sklepie firmowym osoba jest znana z konta:
       pola wypełniamy z konta i chowamy; do zgłoszenia idą jak dotąd */
    (function () { var A = window.KO_API; if (!A) return; var o = (A.osoby || []).find(function (x) { return x.id === A.ja; }); if (!o || !o.mail) return;
      var fi = panel.querySelector('input[name="imie"]'), fe = panel.querySelector('input[name="email"]'); if (!fi || !fe) return; fi.value = o.nazwa || ''; fe.value = o.mail;
      var blok = fi.closest('.sbp-dwa'); if (blok && blok.contains(fe)) blok.style.display = 'none'; else { fi.closest('.sbp-pole').style.display = 'none'; fe.closest('.sbp-pole').style.display = 'none'; } })();
    document.documentElement.classList.add('sbp-blokada');
    panel.querySelector('.sbp__x').addEventListener('click', zamknij);
    var form = panel.querySelector('form');
    form.addEventListener('submit', wyslij);
    var plik = panel.querySelector('#sbp-plik');
    if (plik) plik.addEventListener('change', function () { pokazPliki(plik); });
    document.addEventListener('keydown', klawisz);
    var wst = zrodlo && zrodlo.getAttribute && zrodlo.getAttribute('data-wstep'), op = panel.querySelector('#sbp-opis');
    if (wst && op) op.value = wst;
    requestAnimationFrame(function () {
      tlo.classList.add('on'); panel.classList.add('on');
      var pierwsze = panel.querySelector('textarea, input:not([type=hidden]):not(.sbp-miod):not([type=file])');
      if (pierwsze) pierwsze.focus({ preventScroll: true });
    });
  }

  function pokazPliki(inp) {
    var ul = panel.querySelector('.sbp-pliki');
    ul.innerHTML = [].slice.call(inp.files).map(function (f) {
      var za = f.size > MAX_PLIK;
      return '<li' + (za ? ' class="za-duzy"' : '') + '>' + esc(f.name) + (za ? ' · za duży (max 25 MB)' : '') + '</li>';
    }).join('');
  }

  function blad(t) {
    var b = panel.querySelector('.sbp-blad');
    b.textContent = t; b.hidden = !t;
  }

  function wyslij(e) {
    e.preventDefault();
    var form = e.target;
    var brak = [].slice.call(form.querySelectorAll('[required]')).filter(function (x) { return !x.value.trim(); });
    form.querySelectorAll('.sbp-pole').forEach(function (p) { p.classList.remove('zle'); });
    if (brak.length) { brak.forEach(function (x) { x.closest('.sbp-pole').classList.add('zle'); }); brak[0].focus(); blad(T('Uzupełnij zaznaczone pola.')); return; }
    var em = form.querySelector('[name=email]');
    if (em && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em.value.trim())) { em.closest('.sbp-pole').classList.add('zle'); em.focus(); blad(T('Sprawdź adres e-mail.')); return; }
    var inp = form.querySelector('#sbp-plik');
    if (inp && [].some.call(inp.files, function (f) { return f.size > MAX_PLIK; })) { blad(T('Plik jest za duży — maksymalnie 25 MB.')); return; }
    blad('');

    var fd = new FormData(form);
    form.querySelectorAll('[data-do-opisu]').forEach(function (x) { if (x.value.trim()) fd.set('opis', (fd.get('opis') || '') + '\n' + x.getAttribute('data-do-opisu') + ': ' + x.value.trim()); fd.delete(x.name); });
    fd.append('typ', otwarty.typ);
    fd.append('sklep', location.hostname);
    fd.append('url', location.href);
    fd.append('kontekst', JSON.stringify(otwarty.ctx || {}));
    var cta = form.querySelector('.sbp__cta');
    cta.disabled = true; cta.classList.add('laduje');

    fetch(URL_WORKERA, { method: 'POST', body: fd })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (w) {
        if (!w.ok || !w.j.ok) throw new Error(w.j && w.j.blad || 'blad');
        potwierdz(fd, w.j, otwarty.sprawa);
      })
      .catch(function () {
        cta.disabled = false; cta.classList.remove('laduje');
        blad(T('Nie udało się wysłać. Spróbuj jeszcze raz za chwilę.'));
      });
  }

  /* [Yuri 2026-10-07] „ten ekran jest niedopracowany”. Potwierdzenie mówi teraz, CO DALEJ: numer zgłoszenia,
     do kiedy i na jaki adres odpiszemy (termin liczy Worker - 4 h robocze), co klient dostanie przy tej sprawie,
     a pod spodem to, co wysłał. Ptaszek w kolorze CTA marki (był zielony spoza systemu). */
  var CO_DOSTANIESZ = {
    nadruk: T('Przygotujemy projekt nadruku'),
    wycena: T('Dostaniesz wycenę z terminem realizacji'),
    zamowienie: T('Sprawdzimy zamówienie i odpiszemy ze szczegółami'),
    szukam: T('Podeślemy propozycje produktów'),
    zestaw: T('Podeślemy propozycję zestawu z wyceną'),
    personalizacja: T('Przygotujemy projekt personalizacji'),
    rozmiary: T('Podpowiemy rozkład rozmiarów'),
    kontakt: T('Odpiszemy na Twoją wiadomość'),
    technika: T('Dobierzemy technikę i przygotujemy projekt'),
    projekt: T('Przygotujemy projekt'),
    termin: T('Potwierdzimy termin i sposób dostawy'),
    pomysl: T('Podeślemy propozycję z wyceną')
  };
  function potwierdz(fd, odp, sprawa) {
    odp = odp || {};
    var ctx = otwarty.ctx || {}, typ = sprawa || otwarty.typ;
    var wiersze = [];
    if (ctx.tytul) wiersze.push([T('Produkt'), [ctx.tytul, ctx.wariant].filter(Boolean).join(' · ')]);
    if (fd.get('numer_zamowienia')) wiersze.push([T('Zamówienie'), fd.get('numer_zamowienia')]);
    if (fd.get('ilosc')) wiersze.push([T('Ilość'), fd.get('ilosc') + T(' szt.')]);
    if (fd.get('termin')) wiersze.push([T('Termin'), fd.get('termin')]);
    if (fd.get('opis')) wiersze.push([T('Opis'), fd.get('opis')]);
    var pliki = fd.getAll('pliki').filter(function (f) { return f && f.name; }).map(function (f) { return f.name; });
    if (pliki.length) wiersze.push([T('Pliki'), pliki.join(', ')]);
    var email = String(fd.get('email') || ''), imie = String(fd.get('imie') || '').trim().split(/\s+/)[0];
    var teraz = new Date(), godzTeraz = String(teraz.getHours()).padStart(2, '0') + ':' + String(teraz.getMinutes()).padStart(2, '0');
    var dataTeraz = String(teraz.getDate()).padStart(2, '0') + '.' + String(teraz.getMonth() + 1).padStart(2, '0');
    /* [Jerzy 19.10: „idiotyczny diagram… nie usuwaj, tylko zaproponuj coś, co ma sens i ładnie wygląda”; „bez takich deklaracji” (godzina odpowiedzi)]
       Zamiast osi trzech kroków (dwa z nich mówiły to samo): BILET zgłoszenia. To, co klient wysłał, staje się jednym dokumentem z numerem
       jak stempel (ląduje chwilę po bilecie), datą i godziną przyjęcia, zdaniem o tym, co dostanie, i adresem, na który przyjdzie odpowiedź.
       Bez obietnicy godziny: termin odpowiedzi nie jest deklarowany. */
    var n = 0;
    panel.querySelector('form').outerHTML =
      '<div class="sbp__tresc sbp-ok"><div class="sbp-ok__znak sbp-wej" style="--i:' + (n++) + '" aria-hidden="true">' +
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M5 12.5l4.5 4.5L19 7.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></div>' +
      '<h3 class="sbp-wej" style="--i:' + (n++) + '">' + (imie ? 'Dziękujemy, ' + esc(imie) + '.' : T('Dziękujemy.')) + '<br>' + T('Mamy Twoje zgłoszenie.') + '</h3>' +
      '<div class="sbp-bilet sbp-wej" style="--i:' + (n++) + '">' +
        '<div class="sbp-bilet__g"><span class="sbp-bilet__st">' + T('Przyjęte') + '</span><span class="sbp-bilet__kiedy">' + dataTeraz + ', ' + godzTeraz + '</span>' +
          (odp.numer ? '<span class="sbp-bilet__nr" aria-label="' + T('Numer ') + esc(odp.numer) + '">' + esc(odp.numer) + '</span>' : '') + '</div>' +
        '<div class="sbp-bilet__t"><p><b>' + T('Co dalej') + '</b>' + esc(CO_DOSTANIESZ[typ] || T('Ustalimy szczegóły i odpiszemy')) + '.</p>' +
          (email ? '<p><b>' + T('Odpowiedź') + '</b>' + T('na adres ') + esc(email) + '</p>' : '') +
          (wiersze.length ? '<dl>' + wiersze.map(function (w) { return '<div><dt>' + w[0] + '</dt><dd>' + esc(w[1]) + '</dd></div>'; }).join('') + '</dl>' : '') +
        '</div></div>' +
      '</div>' +
      '<div class="sbp__dol"><button type="button" class="sbp__cta sbp-wej" style="--i:' + (n++) + '">' + T('Wróć do sklepu') + '</button>' +
      '<button type="button" class="sbp-kolejne sbp-wej" style="--i:' + (n++) + '">' + T('Wyślij kolejne zgłoszenie') + '</button></div>';
    var b = panel.querySelector('.sbp__dol .sbp__cta');
    b.addEventListener('click', zamknij); b.focus();
    panel.querySelector('.sbp-kolejne').addEventListener('click', function () { zamknij(); setTimeout(function () { otworz(sprawa || typ); }, 320); });
  }

  document.addEventListener('click', function (e) {
    var w = e.target.closest && e.target.closest('[data-sb-pomoc]');
    if (!w) return;
    e.preventDefault();
    otworz(w.getAttribute('data-sb-pomoc'), w);
  });

  window.sbPomoc = otworz;
})();

/* „Nie ma tego, czego szukasz?” — ZAWSZE ostatni kafel siatki [Yuri 07.10, 08.10].
   Horizon dociąga kolejne strony kategorii, biorąc z nich tylko karty produktów
   (`[ref="cards[]"]`), i dokleja je ZA naszym kaflem z pierwszej strony. Kafel nie ma
   `ref`, więc nie miesza w liczeniu stron — tylko po każdej dostawce wraca na koniec. */
(function () {
  function naKoniec(lista) {
    var k = lista.querySelectorAll(':scope > .product-grid__item--pomoc');
    for (var i = 1; i < k.length; i++) k[i].remove();
    if (k[0] && lista.lastElementChild !== k[0]) lista.appendChild(k[0]);
  }
  function pilnuj() {
    document.querySelectorAll('.product-grid__item--pomoc').forEach(function (k) {
      var lista = k.parentElement;
      if (!lista || lista.__sbPilnuj) return;
      lista.__sbPilnuj = true;
      new MutationObserver(function () { naKoniec(lista); }).observe(lista, { childList: true });
      naKoniec(lista);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pilnuj); else pilnuj();
  /* filtr podmienia całą sekcję — nowa lista, nowy strażnik */
  new MutationObserver(pilnuj).observe(document.documentElement, { childList: true, subtree: true });
})();
